import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import { FC, useMemo } from 'react';
import { EquipmentDto } from '../../dtos';
import { useGetEquipmentQuery } from '../../store/generated/generatedApi';
import { IEntityAutocomplete } from './IEntityAutocomplete';

export interface IEquipmentAutocompleteProps {
    initialEquipment?: EquipmentDto;
    formEquipment?: EquipmentDto;
    handleEquipmentChange: (selectedEquipment?: EquipmentDto) => void;
    required?: boolean;
    errorMessage?: string;
}

export const EquipmentAutocomplete: FC<IEquipmentAutocompleteProps> = props => {
    const { initialEquipment, formEquipment, handleEquipmentChange, required, errorMessage } = props;

    const { data: equipment, isLoading: equipmentLoading } = useGetEquipmentQuery({ searchText: '', sorting: ['NUMBER+'], page: 0, pageSize: 100000, includeInactive: false });

    const equipmentResults: EquipmentDto[] = useMemo(() => {
        if (!equipment) {
            return [];
        }
        if (!initialEquipment || equipment.pageResults.some(x => x.id === initialEquipment.id)) {
            return equipment.pageResults;
        }
        return [initialEquipment, ...equipment.pageResults];
    }, [equipment, initialEquipment])

    // Equipment already assigned to another driver stays visible but can't be picked: a piece of
    // equipment belongs to one driver at a time. Reassigning is done from the Equipment edit screen.
    const isAssignedElsewhere = (option: EquipmentDto) => option.hasDriver && option.id !== initialEquipment?.id;

    return (
        <FormControl fullWidth required={required} error={!!errorMessage}>
            <FormLabel>Assigned Equipment</FormLabel>
            <IEntityAutocomplete
                options={equipmentResults}
                onChange={(e, value) => { handleEquipmentChange(value ?? null); }}
                value={formEquipment}
                getOptionLabel={(option: EquipmentDto) => `${option.number} - ${option.equipmentType?.type}${isAssignedElsewhere(option) ? ' - (Assigned)' : ''}`}
                getOptionDisabled={isAssignedElsewhere}
                isLoading={equipmentLoading}
                error={!!errorMessage}
            />
            <FormHelperText>{errorMessage}</FormHelperText>
        </FormControl>
    )
}